import MUIAccordion from '@mui/material/Accordion'

export const Accordion = MUIAccordion
